import { render, staticRenderFns } from "./DesktopView.vue?vue&type=template&id=1cddca9b&"
import script from "./DesktopView.vue?vue&type=script&lang=js&"
export * from "./DesktopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports